import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "designSystem/components/button/Button";
import { grey } from "designSystem/styles/color";
import FlexColumn from "designSystem/components/flex/FlexColumn";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import CentricIcon from "designSystem/components/icon/CentricIcon";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import Placeholder from "designSystem/components/placeholder/Placeholder";
import { useStore } from "csi/state/hooks";
import React from "react";
import { HeaderCallbacks } from "../../types";
import SlackIcon from "../icon/SlackIcon";
import { getAskSlackPermissionsUrl } from "../util";

type Props = HeaderCallbacks;

const JoinSlack: React.FunctionComponent<Props> = ({ onBack, onClose }) => {
	const { routerStore } = useStore();
	const { locationNode } = routerStore;
	const askSlackPermissionsUrl = getAskSlackPermissionsUrl();
	return (
		<FlexColumn>
			<PaneHeader
				back={false}
				onBack={onBack}
				onClose={onClose}
				titleRes="Slack"
			/>
			<FlexRowCenter
				flexGrow={1}
				justifyContent="center"
				px={3}
			>
				<Placeholder
					subtitleMargin={6}
					subtitleProps={{ res: "SignInToSlackPlaceholderText" }}
					titleProps={{ res: "SignInToSlackPlaceholderTitle" }}
				>
					{{
						actions:
							<Button
								design="primary"
								onClick={() => window.location.assign(askSlackPermissionsUrl)}
								res="SignInToSlackButton"
							/>
						,
						image:
							<Box>
								<Box
									color={grey[300]}
									component="span"
									height={63}
								>
									<CentricIcon removeFillColor={locationNode?.SlackChannels?.length} style={{ fontSize: 63, verticalAlign: "middle" }} />
								</Box>
								<Box
									color={grey[300]}
									component="span"
									height={24}
								>
									<ArrowForwardIcon style={{ fontSize: 24, position: "relative", top: "0", left: "12px" }} />
								</Box>
								<Box
									color={grey[300]}
									component="span"
									height={24}
								>
									<ArrowBackIcon style={{ fontSize: 24, position: "relative", top: "20px", left: "-12px" }} />
								</Box>
								<Box
									color={grey[300]}
									component="span"
									height={45}
								>
									<SlackIcon mono style={{ fontSize: 45, verticalAlign: "middle" }} />
								</Box>
							</Box>,
					}}
				</Placeholder>
			</FlexRowCenter>
		</FlexColumn>
	);
};

export default JoinSlack;
